module.exports = __webpack_public_path__ + "static/media/pic1.c7a280f2.png";